export default __webpack_public_path__ + "static/media/automatskavrata5.10e67188.png";